import React from "react";
import { View, StyleSheet } from "react-native";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtCaseStudyText from "./NtCaseStudyText";
import NtCaseStudyTextBold from "./NtCaseStudyTextBold";
import NtCaseStudyTextBullet from "./NtCaseStudyTextBullet";

function NtCaseStudyTritan(props) {
  return (
    <NtCaseStudySectionContainer
      style={styles.container}
      title={
        "Enabling a Safe Return to Cruising with NT Maritime’s Health Monitoring System"
      }
    >
      <NtCaseStudyText style={{}}>
        <NtCaseStudyTextBold>Overview</NtCaseStudyTextBold>
        {"\n\n"}As the cruise industry works to regain passenger confidence and
        safely return to full operations, health and safety have become top
        priorities. The introduction of the NT Maritime Health Monitoring
        System, seamlessly integrated with the Tritan Software SeaCare platform,
        has given cruise lines an advanced tool to detect and contain health
        issues early, ensuring a safer and more reassuring experience for both
        passengers and crew.{"\n\n"}
        <NtCaseStudyTextBold>The Challenge</NtCaseStudyTextBold>
        {"\n\n"}Cruise ships are essentially floating cities — dense, social
        environments where viruses can quickly spread and disrupt operations.
        Even a single infected passenger can jeopardize an entire voyage,
        negatively affecting thousands of guests and crew members, and
        potentially sidelining a ship for extended periods.{"\n\n"}In a
        post-pandemic world, rebuilding public trust in cruising requires
        comprehensive health screening and rapid response capabilities that go
        beyond traditional medical centers and manual processes.{"\n\n"}
        <NtCaseStudyTextBold>The Solution</NtCaseStudyTextBold>
        {"\n\n"}NT Maritime, known for its integrated passenger and crew
        communications solutions, introduced a contactless, real-time health
        monitoring system designed specifically for maritime environments. By
        combining advanced screening technologies with seamless communication,
        this solution enables cruise lines to intercept and contain health
        problems at their source — immediately and effectively.{"\n\n"}
        <NtCaseStudyTextBold>Key Features Include</NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Noninvasive Health Screening:</NtCaseStudyTextBold>{" "}
        Regular checks for pulse, respiration rate, and rhythm. Upcoming
        enhancements include fever detection and SpO2 oxygen saturation
        monitoring.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Chat-Bot Triage:</NtCaseStudyTextBold> A dynamic,
        questionnaire-based tool following current hospital triage protocols,
        with photo verification to confirm identity.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Flexible Screening Options:</NtCaseStudyTextBold>{" "}
        Configurable by location, time intervals, or self-reporting before
        passengers leave their cabins — not limited to embarkation and
        debarkation checks.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Public Area Checks:</NtCaseStudyTextBold> Guests
        are screened before entering public spaces, and crew members are
        regularly checked before interacting with guests or accessing work
        areas.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Virtual Medical Support</NtCaseStudyTextBold>
        {"\n\n"}If a passenger needs to be quarantined, the NT Maritime system
        facilitates virtual medical consultations directly from the cabin. Using
        their mobile devices and the cruise line's app, passengers can:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Communicate via voice, video, walkie-talkie, and chat.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Receive assessments from onboard medical teams and shore-side doctors.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Undergo certain vital checks using their phone’s camera — all without
        exposing medical staff or other guests.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          Advanced Contact Tracing & Containment
        </NtCaseStudyTextBold>
        {"\n\n"}Once a sick individual is identified, the system’s contact
        tracing feature locates anyone who may have been exposed, enabling
        immediate testing and possible quarantine. It also flags onboard
        locations that require enhanced sanitization, further minimizing risk to
        others.{"\n\n"}Roger Blum of Cruise & Port Advisors, representing NT
        Maritime to the cruise industry, emphasized the system’s versatility:
      </NtCaseStudyText>

      <NtCaseStudyText
        style={{ marginTop: 20, marginRight: 30, marginLeft: 30 }}
      >
        “Cruise lines will be able to monitor, do contact tracing, and minimize
        visits to the medical center since people can chat or have a video
        consultation with a doctor. This also allows virtual consultations for
        non-COVID issues, such as cuts, reducing potential exposure in a waiting
        room.”
      </NtCaseStudyText>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Results & Impact</NtCaseStudyTextBold>
        {"\n\n"}The NT Maritime Health Monitoring System addresses critical
        health concerns head-on, providing passengers with a higher level of
        confidence and safety onboard. By enabling rapid detection, minimizing
        onboard medical center visits, and offering comprehensive virtual care,
        the system supports cruise lines in restoring operations and attracting
        health-conscious travelers back to sea.{"\n\n"}As the industry seeks to
        return to pre-pandemic levels, this advanced health solution plays a
        vital role in rebuilding trust — making cruising not just enjoyable
        again, but also demonstrably safe.{"\n\n"}
        <NtCaseStudyTextBold>Conclusion</NtCaseStudyTextBold>
        {"\n\n"}The NT Maritime Health Monitoring System is more than a
        technical innovation — it is a strategic enabler of the entire
        industry’s recovery. Cruise lines that adopt it can demonstrate a
        serious commitment to health and safety, reassure hesitant guests, and
        position themselves for long-term success in a transformed travel
        landscape.
      </NtCaseStudyText>
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtCaseStudyTritan;
